import {HTTP} from '@/http-common';

const state = {
  loading: false,
  templates: [],
  currentTemplate: {
    id: null,
    name: '',
    description: '',
    options: [],
  }
}

const mutations = {
  SET_TEMPLATES(state, data) {
      state.templates = data
  },
  SET_LOADING(state, data) {
      state.loading = data
  },
  SET_CURRENT_TEMPLATE(state, data) {
      state.currentTemplate = data
  },
}

const getters = {
  getLoading: state => state.loading,
  getFieldTemplates: state => state.templates,
  getCurrentFieldTemplate: state => state.currentTemplate,
}

const actions = {
  async fetchFieldTemplates({state, commit}) {
    if (!state.loading && state.templates.length === 0){
      commit('SET_LOADING', true);
      const response = await HTTP.get('/fields_templates/');
      if (response.data.status === 'success') {
        commit('SET_TEMPLATES', response.data.data);
        commit('SET_LOADING', false);
      } else {

      }
    }
    return state.templates;
  },
  async fetchFieldTemplateById({state, commit}, payload) {
    commit('SET_LOADING', true);
    const response = await HTTP.get(`/fields_templates/${payload.id}`);
    if (response.data.status === 'success') {
      commit('SET_CURRENT_TEMPLATE', response.data.data[0]);
      commit('SET_LOADING', false);
    } else {

    }
    return response.data.data;
  },
  async createFieldTemplate({state, commit, dispatch}, payload) {
    commit('SET_LOADING', true);
    const response = await HTTP.post('/fields_templates/', payload);
    if (response.data.status === 'success') {
      commit('SET_LOADING', false);
    } else {
      commit('SET_LOADING', false);
    }
  },
  async updateFieldTemplate({state, commit, dispatch, ...rest}, payload) {
    commit('SET_LOADING', true);
    const response = await HTTP.put(`/fields_templates/${payload.id}`, payload);
    if (response.data.status === 'success') {
      commit('SET_LOADING', false);
    } else {
      commit('SET_LOADING', false);
    }
  },
  async removeFieldTemplate({state, commit, dispatch}, payload) {
    commit('SET_LOADING', true);
    const response = await HTTP.delete(`/fields_templates/${payload.id}`, payload);
    if (response.data.status === 'success') {
      commit('SET_LOADING', false);
      dispatch('fetchFieldTemplates');
    } else {
      commit('SET_LOADING', false);
    }
  }
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/fieldTemplates.js